import { LOGIN, LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT, LOGOUT_ERROR, LOGOUT_SUCCESS } from "../constants/authConstants";
import { API_URL_V2 } from '../constants/index.js';


//#region LOGIN

function startLogin(data) {
    return {
        type: LOGIN,
        data
    }
};

function LoginSuccess(data) {
    return {
        type: LOGIN_SUCCESS,
        data
    }
};

function LoginError(data) {
    return {
        type: LOGIN_ERROR,
        data
    }
};

export function Login(user, password) {
    return async (dispatch) => {
        dispatch(startLogin());

        const resp = await fetch(API_URL_V2 + 'loginCms/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'user': user,
                    'pass': password
                }
            });

        let body;

        if (resp.status === 204) {
            body = {
                success : false,
                error: "This user does not have access. Please contact an administrator."
            }
            dispatch(LoginError(body));
        } else {
            body = await resp.json()
            if (body.success) {
                localStorage.setItem('token', body.newToken)
                body.communityId !== undefined && localStorage.setItem('communityId', body.communityId)
                body.isSuperAdmin = !body.communityId ? true : false;

                localStorage.setItem('token', body.newToken);
                localStorage.setItem('superAdmin', body.isSuperAdmin);
                localStorage.setItem('givenName', body.given_name);
                localStorage.setItem('familyName', body.family_name);
                localStorage.setItem('username', body.userName);

                dispatch(LoginSuccess(body));
            } else {
                dispatch(LoginError(body.error));
            }
        }

        return body;
    }
};


//#endregion LOGIN

//#region LOGOUT

function startlogut(data) {
    return {
        type: LOGOUT,
        data
    }
};


function LogoutSuccess(data) {
    return {
        type: LOGOUT_SUCCESS,
        data
    }
};

function LogoutError(data) {
    return {
        type: LOGOUT_ERROR,
        data
    }
};

export const loginValidation = () => {
    return async (dispatch) => {
        dispatch(startLogin());
        // Validate if localStorage have information
        try {
            let loginInfo = {
                newToken: localStorage.getItem("token"),
                communityId: localStorage.getItem('communityId'),
                isSuperAdmin: localStorage.getItem("superAdmin"),
                given_name: localStorage.getItem("givenName"),
                family_name: localStorage.getItem("familyName"),
                userName: localStorage.getItem("username")
            }
            if (!loginInfo.newToken) {
                return
            } else {
                return dispatch(LoginSuccess(loginInfo));
            }
        } catch (error) {
            return dispatch(LoginError(error));
        }

    }
}

export function LogoutProccess() {
    return async (dispatch) => {
        dispatch(startlogut());

        try {
            localStorage.clear();
            dispatch(LogoutSuccess())
        } catch (error) {
            dispatch(LogoutError())
        }
    }
};

//#endregion LOGOUT
